import appVersion from "../../../../shared/app-version.json";

export const APP_NAME = appVersion.name;
export const APP_VERSION = appVersion.version;
export const APP_DISPLAY_VERSION = `Version ${APP_VERSION}`;
export const APP_BUILD_SHA = import.meta.env.VITE_BUILD_SHA || "dev";
export const APP_BUILD_TIME = import.meta.env.VITE_BUILD_TIME || "dev";
export const APP_DISPLAY_BUILD =
  APP_BUILD_SHA === "dev" || APP_BUILD_SHA === "unknown"
    ? APP_BUILD_SHA
    : APP_BUILD_SHA.slice(0, 7);

export const APP_DISPLAY_PLATFORM = "Web Browser";
export const APP_DISPLAY_BUILD_LABEL = `Web ${APP_VERSION}`;
export const APP_FOOTER_BUILD_LABEL = `Build Web ${APP_VERSION}`;

export function formatAppBuildTime(buildTime: string = APP_BUILD_TIME): string {
  if (!buildTime || buildTime === "dev" || buildTime === "unknown") {
    return buildTime === "dev" ? "dev" : "—";
  }
  const parsed = new Date(buildTime);
  if (Number.isNaN(parsed.getTime())) {
    return buildTime;
  }
  return parsed.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
